import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { StepperOrientation } from '@angular/cdk/stepper';
import { ADVANCED_PLANTS_LIMIT, isNotNullOrUndefined, RoleService, Systems, SystemsService } from 'ngx-core-services';
import { combineLatest, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { labels } from './create.model';
import { ChooseState } from './create-block.model';
import { getLoggerState } from '../create-firebase/create.utils';

@Component({
  selector: 'create-block',
  templateUrl: './create-block.component.html',
  styleUrls: ['./create-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateBlockComponent {
  readonly _labels = labels;
  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
  }
  get labels(): typeof this._labels {
    return { ...this._labels };
  }

  @Input() stepperOrientation: StepperOrientation = 'horizontal';
  @Input() systems$?: Observable<Systems | undefined>;

  @Output() wizardFinished = new EventEmitter<string>();
  @Output() wizardExit = new EventEmitter<void>();

  plantType: ChooseState[] = [];
  readonly plantTypeIcons = [];
  readonly unlimitedPlants$ = this.roleService.has_somePermission$;

  readonly canCreateAdvancedPlant$ = combineLatest([
    this.systemService.awsSystems$.pipe(isNotNullOrUndefined()),
    this.unlimitedPlants$,
  ]).pipe(
    tap(([systems, hasPermission]) => {
      const createVerifiedIsEnable = hasPermission || systems.length < ADVANCED_PLANTS_LIMIT;
      const disableVerified = !createVerifiedIsEnable;
      const mutuallyExclusive = true;

      this.plantType = [];
      this.plantType.push(getLoggerState('legacyPlant', 2, 'blocks-assets/images/generics/plant.svg', this.plantType, mutuallyExclusive));
      this.plantType.push(getLoggerState('verifiedPlant', 1, 'blocks-assets/images/generics/verified-plant.svg', this.plantType, mutuallyExclusive, disableVerified));
    })
  );

  get isPlantTypeSelected(): boolean {
    return this.plantType.some(({ checked$ }) => checked$.value);
  }

  mode?: 'aws' | 'firebase';

  constructor(
    private readonly roleService: RoleService,
    private readonly systemService: SystemsService,
  ) { }

  confirmPlantType() {
    const selected = this.plantType.find(({ checked$ }) => checked$.value);
    if (!selected || !selected.name || !['verifiedPlant', 'legacyPlant'].includes(selected.name)) {
      return;
    }
    this.mode = selected.name === 'verifiedPlant' ? 'aws' : 'firebase';
  }

  reset() {
    this.mode = undefined;
    this.plantType.forEach(({ checked$ }) => checked$.next(false));
  }
}
